import Vue from 'vue';
import Router from 'vue-router';
import Labao from '@/module/labao/router';
import Coupon from '@/module/coupon/router';
import { webcall } from '@/commons/tools';

const hiddenRightItemRoutes = [
  'reportingCenterPendingReport',
  'reportingCenterClaimStatus',
];

Vue.use(Router);

const routes = [...Labao, ...Coupon];

// 创建路由实例
const router = new Router({
  routes: routes, // 路由配置
});

// 导航守卫，前置钩子
router.beforeEach((to, from, next) => {
  // 修改页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else if (to.query && to.query.doc_title) {
    document.title = to.query.doc_title;
  }

  if (hiddenRightItemRoutes.indexOf(to.name) > -1) {
    // 隐藏客户端右上角按钮
    webcall({
      action: 'setRightItem',
      title: ' ',
      callback: '',
    });
  }

  next();
});

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

export default router;
